import { Injectable } from '@angular/core'
import { WebService } from '../api/web.service'
import { ServiceUrlConstants } from 'src/app/constants/service-url-constants'
import { Observable, map } from 'rxjs'
import { QueriesAPIModel, ModuleDashboardAPIModel, PaginatedAPI } from 'src/app/models/api.model'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/store/state/app.state'
import { QueriesDashboardModel } from 'src/app/models/model'
import {
  DELETE_QUERY_DETAILS,
  FETCH_QUERY_DETAILS,
  UPDATE_QUERY_ACTION,
  fetch_query_dashboard_data,
  save_query_action
} from 'src/app/store/action/query.action'
import { getQueryDashboardInfo, getQueryDetails } from 'src/app/store/selector/query.selector'

@Injectable({
  providedIn: 'root'
})
export class QueryService {
  constructor(private webservice: WebService, private appState: Store<AppState>) {}

  dispatchFetchQueryDashboardDataAction(days: number, sortBy: string, sortOrder: string) {
    this.appState.dispatch(fetch_query_dashboard_data({ days, sortBy, sortOrder }))
  }

  callDashboardApi = (days: number, sortBy: string, sortOrder: string) => {
    const endPoint = `${ServiceUrlConstants.API_QUERIES_DASHBOARD}?days=${days}&sortBy=${sortBy}&sortOrder=${sortOrder}`
    return this.webservice.get(endPoint).pipe(map((data: ModuleDashboardAPIModel) => data))
  }

  getQueryDashboardInfo(): Observable<QueriesDashboardModel> {
    return this.appState.select(getQueryDashboardInfo())
  }

  dispatchSaveQueryAction(query: QueriesAPIModel, files: FileList, routeTo: string) {
    this.appState.dispatch(save_query_action({ query, files, routeTo }))
  }

  callSaveApi = (query: QueriesAPIModel, files: FileList) => {
    const endPoint = ServiceUrlConstants.API_SAVE_QUERY
    const formData: FormData = new FormData()
    const queryBlob = new Blob([JSON.stringify(query)], { type: 'application/json' })
    formData.append('query', queryBlob)

    if (files) {
      for (let i = 0; i < files.length; i++) {
        formData.append('documentList', files[i])
      }
    }

    return this.webservice.post(endPoint, formData, null, [], false).pipe(map((data: QueriesAPIModel) => data))
  }

  dispatchFetchQueryDetailsAction(id: string) {
    return this.appState.dispatch(FETCH_QUERY_DETAILS({ id }))
  }

  callQueryDetailsApi = (id: string) => {
    const endPoint = `${ServiceUrlConstants.API_FETCH_QUERY_DETAILS}${id}`
    return this.webservice.get(endPoint).pipe(map((data: QueriesAPIModel) => data))
  }

  getQueryDetailsFromStore = (): Observable<QueriesAPIModel> => {
    return this.appState.select(getQueryDetails())
  }

  dispatchUpdateQueryAction(query: Partial<QueriesAPIModel>, id: string, files: File[], routeTo: string) {
    this.appState.dispatch(UPDATE_QUERY_ACTION({ query, id, files, routeTo }))
  }

  callUpdateApi = (query: Partial<QueriesAPIModel>, id: string, files?: File[]) => {
    const endPoint = ServiceUrlConstants.API_UPDATE_QUERY + id
    const formData: FormData = new FormData()
    const queryBlob = new Blob([JSON.stringify(query)], { type: 'application/json' })
    formData.append('queries', queryBlob)

    if (files) {
      for (let i = 0; i < files.length; i++) {
        formData.append('documentList', files[i])
      }
    }

    return this.webservice.put(endPoint, formData, null, [], false).pipe(map((data: QueriesAPIModel) => data))
  }

  dispatchDeleteQueryDetailsAction() {
    return this.appState.dispatch(DELETE_QUERY_DETAILS())
  }

  invokeQuerySummaryAPI = (queryParams: { key: string; value: string }[], searchRequestBody) => {
    return this.webservice
      .post(ServiceUrlConstants.API_QUERY_LIST, searchRequestBody, null, queryParams)
      .pipe(map((data: PaginatedAPI<QueriesAPIModel>) => data))
  }
}
